import React, { Ref, RefObject, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonProps } from '../../../button/Button';
import { EntityFormImperativeRef, EntityFormProps } from '../../../entity-form/EntityForm';
import { EditEntityWizard } from './EditEntityWizard';
import { TestConnectionPropsFactory } from '../../../entity-form/factories/testConnectionPropsFactory';

interface EditEntityProps<
  P extends Pick<EntityFormProps, 'onStateChange' | 'onComplete' | 'formImperativeRef'>
> {
  FormComponent: React.FC<P>;
  componentProps?: Partial<P>;
  cancelUrl: string;
  isCancelUrlPathRelative: boolean;
  name: string;
}

export function EditEntity<
  P extends Pick<EntityFormProps, 'onStateChange' | 'onComplete' | 'formImperativeRef'>
>({ FormComponent, componentProps, name, isCancelUrlPathRelative, cancelUrl }: EditEntityProps<P>) {
  const navigate = useNavigate();
  const [submitBtnProps, setSubmitBtnProps] = useState<Partial<ButtonProps>>({});
  const formRef = useRef<EntityFormImperativeRef>();

  return (
    <EditEntityWizard
      name={name}
      submitButtonProps={submitBtnProps}
      cancelUrl={cancelUrl}
      isCancelUrlPathRelative={isCancelUrlPathRelative}
    >
      <FormComponent
        {...(componentProps as P)}
        formImperativeRef={formRef as unknown as Ref<EntityFormImperativeRef>}
        onComplete={() => navigate(-1)}
        onStateChange={state => {
          const props = TestConnectionPropsFactory(
            state,
            formRef as RefObject<EntityFormImperativeRef>
          );
          setSubmitBtnProps(props);
        }}
      />
    </EditEntityWizard>
  );
}
